import React from 'react';

const NumberMiniViz: React.FC<{ value: number }> = ({ value }) => (
  <span className="dib blue fw5">{value}</span>
);

export default NumberMiniViz;
